<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-details-card card-padding-top">
                <app-empty-content [isVisible]="data.length === 0"
                    title="Nenhum representante encontrado"
                    description="Não foi encontrado nenhum representante nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <div class="table-scroll-container" *ngIf="data.length > 0">
                    <table class="table">
                        <thead>
                            <tr>
                                <th style="margin-bottom: 16px;">Nome</th>
                                <th style="margin-bottom: 16px;">Mandato</th>
                                <th class="text-center"
                                    style="margin-bottom: 16px;">Tipo</th>
                                <th class="text-center"
                                    style="margin-bottom: 16px;">Assinou</th>
                                <th class="text-center"
                                    style="margin-bottom: 16px;">Ass. necessária
                                </th>
                                <th class="text-center"
                                    style="margin-bottom: 16px;">Ass.
                                    obrigatória</th>
                                <th style="margin-bottom: 16px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of data">
                                <td>
                                    <div>{{ item.company &&
                                        item.company.corporate_name ?
                                        item.company.corporate_name :
                                        item.full_name }}</div>
                                    <div
                                        class="app-table-details-body-row-subtitle">
                                        {{ item.company &&
                                        item.company.document?.number ?
                                        formatCpfOrCnpj(item.company.document.number)
                                        : (item.document_number ?
                                        formatCpf(item.document_number) : '--')
                                        }}
                                    </div>
                                </td>
                                <td>{{ formatMandate(item.min_term_validity,
                                    item.expiration_date ||
                                    item.max_term_validity) }}</td>
                                <td class="text-center">
                                    {{ getRepresentativeTypeText(item) }}
                                </td>
                                <td class="text-center">
                                    <img
                                        *ngIf="getSignedStatus(item)"
                                        src="/assets/images/carbon-checkmark.svg"
                                        class="comparison-icon" alt="sim" />
                                    <img
                                        *ngIf="!getSignedStatus(item)"
                                        src="/assets/images/carbon-error-warning.svg"
                                        class="comparison-icon" alt="não" />
                                </td>
                                <td class="text-center">
                                    <img
                                        *ngIf="item.can_sign"
                                        src="/assets/images/carbon-checkmark.svg"
                                        class="comparison-icon" alt="sim" />
                                    <img
                                        *ngIf="!item.can_sign"
                                        src="/assets/images/carbon-error-warning.svg"
                                        class="comparison-icon" alt="não" />
                                </td>
                                <td class="text-center">
                                    <img
                                        *ngIf="getMandatorySignature(item)"
                                        src="/assets/images/carbon-checkmark.svg"
                                        class="comparison-icon" alt="sim" />
                                    <img
                                        *ngIf="!getMandatorySignature(item)"
                                        src="/assets/images/carbon-error-warning.svg"
                                        class="comparison-icon" alt="não" />
                                </td>
                                <td class="text-center">
                                    <svg-icon src="assets/images/icon-eye.svg"
                                        style="cursor: pointer;"
                                        (click)="openModalById(item.id)"></svg-icon>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Lado esquerdo - Versão Principal -->
        <div class="col-6">
            <!-- Skeleton bloco cheio para versão principal -->
            <ng-container *ngIf="mainLoading">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container
                *ngIf="!mainLoading && approvalService.approvalData.mainVersion && approvalService.approvalData.mainRevision">
                <div class="dash-details-card card-padding-top">
                    <div class="table-scroll-container">
                        <app-empty-content [isVisible]="mainData.length === 0"
                            title="Nenhum dado encontrado"
                            description="Não foi encontrado nenhum dado de risco nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <table class="table" *ngIf="mainData.length > 0">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Mandato</th>
                                    <th class="text-center">Tipo</th>
                                    <th class="text-center">Assinou</th>
                                    <th class="text-center">Ass. necessária</th>
                                    <th class="text-center">Ass. obrigatória
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of mainData">
                                    <td>
                                        <div>{{ item.company &&
                                            item.company.corporate_name ?
                                            item.company.corporate_name :
                                            item.full_name }}</div>
                                        <div
                                            class="app-table-details-body-row-subtitle">
                                            {{ item.company &&
                                            item.company.document?.number ?
                                            formatCpfOrCnpj(item.company.document.number)
                                            : (item.document_number ?
                                            formatCpf(item.document_number) :
                                            '--') }}
                                        </div>
                                    </td>
                                    <td>{{ formatMandate(item.min_term_validity,
                                        item.expiration_date ||
                                        item.max_term_validity) }}</td>
                                    <td class="text-center">
                                        {{ getRepresentativeTypeText(item) }}
                                    </td>
                                    <td class="text-center">
                                        <img
                                            *ngIf="getSignedStatus(item)"
                                            src="/assets/images/carbon-checkmark.svg"
                                            class="comparison-icon" alt="sim" />
                                        <img
                                            *ngIf="!getSignedStatus(item)"
                                            src="/assets/images/carbon-error-warning.svg"
                                            class="comparison-icon" alt="não" />
                                    </td>
                                    <td class="text-center">
                                        <img
                                            *ngIf="item.can_sign"
                                            src="/assets/images/carbon-checkmark.svg"
                                            class="comparison-icon" alt="sim" />
                                        <img
                                            *ngIf="!item.can_sign"
                                            src="/assets/images/carbon-error-warning.svg"
                                            class="comparison-icon" alt="não" />
                                    </td>
                                    <td class="text-center">
                                        <img
                                            *ngIf="getMandatorySignature(item)"
                                            src="/assets/images/carbon-checkmark.svg"
                                            class="comparison-icon" alt="sim" />
                                        <img
                                            *ngIf="!getMandatorySignature(item)"
                                            src="/assets/images/carbon-error-warning.svg"
                                            class="comparison-icon" alt="não" />
                                    </td>
                                    <td class="text-center">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"
                                            style="cursor: pointer;"
                                            (click)="openModalById(item.id)"></svg-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <app-spacer [bottom]="24"></app-spacer>
            </ng-container>
            <ng-container
                *ngIf="!approvalService.approvalData.mainVersion || !approvalService.approvalData.mainRevision">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>
        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <!-- Skeleton bloco cheio para versão comparando -->
            <ng-container
                *ngIf="(comparingLoading || comparingDataLoading) && approvalService.approvalData.comparingVersion && approvalService.approvalData.comparingRevision">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container
                *ngIf="!comparingLoading && !comparingDataLoading && approvalService.approvalData.comparingVersion && approvalService.approvalData.comparingRevision">
                <div class="dash-details-card card-padding-top">
                    <div class="table-scroll-container">
                        <app-empty-content
                            [isVisible]="comparingData.length === 0"
                            title="Nenhum dado encontrado"
                            description="Não foi encontrado nenhum dado de risco nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <table class="table" *ngIf="comparingData.length > 0">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Mandato</th>
                                    <th class="text-center">Tipo</th>
                                    <th class="text-center">Assinou</th>
                                    <th class="text-center">Ass. necessária</th>
                                    <th class="text-center">Ass. obrigatória
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of comparingData"
                                    [class]="item.compareClass">
                                    <td>
                                        <div
                                            style="display: flex; align-items: center; gap: 8px;">
                                            <img
                                                *ngIf="item.compareClass === 'row-compare-added'"
                                                src="/assets/images/carbon-checkmark.svg"
                                                class="comparison-icon" alt="adicionado" />
                                            <img
                                                *ngIf="item.compareClass === 'row-compare-removed'"
                                                src="/assets/images/carbon-error-warning.svg"
                                                class="comparison-icon" alt="removido" />
                                            <div>
                                                <div>{{ item.name }}</div>
                                                <div
                                                    class="app-table-details-body-row-subtitle">
                                                    {{ item.document ?
                                                    formatCpf(item.document) :
                                                    '--' }}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <img
                                                *ngIf="item.changedFields?.mandate"
                                                src="/assets/images/carbon-warning.svg"
                                                class="comparison-icon" alt="alterado" />
                                            <span>{{ item.mandate }}</span>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div
                                            style="display: flex; align-items: center; justify-content: center; gap: 6px;">
                                            <img
                                                *ngIf="item.changedFields?.representative || item.changedFields?.guarantor || item.changedFields?.solidarityDebtor"
                                                src="/assets/images/carbon-warning.svg"
                                                class="comparison-icon" alt="alterado" />
                                            <span>{{
                                                getRepresentativeTypeText(item)
                                                }}</span>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <img
                                            *ngIf="getSignedStatus(item)"
                                            src="/assets/images/carbon-checkmark.svg"
                                            class="comparison-icon" alt="sim" />
                                        <img
                                            *ngIf="!getSignedStatus(item)"
                                            src="/assets/images/carbon-error-warning.svg"
                                            class="comparison-icon" alt="não" />
                                    </td>
                                    <td class="text-center">
                                        <div
                                            style="display: flex; align-items: center; justify-content: center; gap: 6px;">
                                            <img
                                                *ngIf="item.changedFields?.signed"
                                                src="/assets/images/carbon-warning.svg"
                                                class="comparison-icon" alt="alterado" />
                                            <img
                                                *ngIf="item.can_sign"
                                                src="/assets/images/carbon-checkmark.svg"
                                                class="comparison-icon" alt="sim" />
                                            <img
                                                *ngIf="!item.can_sign"
                                                src="/assets/images/carbon-error-warning.svg"
                                                class="comparison-icon" alt="não" />
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <img
                                            *ngIf="getMandatorySignature(item)"
                                            src="/assets/images/carbon-checkmark.svg"
                                            class="comparison-icon" alt="sim" />
                                        <img
                                            *ngIf="!getMandatorySignature(item)"
                                            src="/assets/images/carbon-error-warning.svg"
                                            class="comparison-icon" alt="não" />
                                    </td>
                                    <td class="text-center">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"
                                            style="cursor: pointer;"
                                            (click)="openModalById(item.id)"></svg-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <app-spacer [bottom]="24"></app-spacer>
            </ng-container>
            <ng-container
                *ngIf="!approvalService.approvalData.comparingVersion || !approvalService.approvalData.comparingRevision">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>
    </div>
</ng-container>

<app-side-modal [active]="representativeDetails"
    [title]="selectedRepresentative?.company?.corporate_name || selectedRepresentative?.representative_register?.company?.corporate_name || selectedRepresentative?.full_name || '--'"
    (onClose)="closeModal()" paddingBottom="30">
    <div class="container" *ngIf="selectedRepresentative">
        <div class="row">
            <!-- Dados da Empresa (quando existir) -->
            <ng-container
                *ngIf="(selectedRepresentative.company && selectedRepresentative.company.corporate_name) || (selectedRepresentative.representative_register?.company && selectedRepresentative.representative_register.company.corporate_name)">
                <div class="col-12 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        RAZÃO SOCIAL
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.company?.corporate_name ||
                        selectedRepresentative.representative_register?.company?.corporate_name}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        CNPJ
                    </span>

                    <span class="dash-details-card-item-title">
                        {{(selectedRepresentative.company?.document?.number ||
                        selectedRepresentative.representative_register?.company?.document?.number)
                        ?
                        formatCpfOrCnpj(selectedRepresentative.company?.document?.number
                        ||
                        selectedRepresentative.representative_register?.company?.document?.number)
                        : '--'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column"
                    *ngIf="isFundApproval()">
                    <span class="dash-details-card-item-subtitle">
                        PERFIL
                    </span>
                    <span class="dash-details-card-item-title">
                        {{ getFundProfile(selectedRepresentative) }}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12">
                    <div class="divider mt-2 mb-2"></div>
                </div>
            </ng-container>

            <ng-container
                *ngIf="companyLookupName || loadingCompanyRepresentatives">
                <div class="col-12">
                    <label class="pep-title">Empresa encontrada</label>
                    <div style="font-weight: 600; font-size: 18px;">
                        <ngx-skeleton-loader
                            *ngIf="loadingCompanyRepresentatives" [theme]="{
                                height: '20px',
                                width: '320px',
                                marginBottom: '0'
                            }">
                        </ngx-skeleton-loader>
                        <ng-container *ngIf="!loadingCompanyRepresentatives">
                            {{ companyLookupName | uppercase }}
                        </ng-container>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                    <label class="pep-title">Representantes vinculados</label>
                    <div *ngIf="loadingCompanyRepresentatives"
                        class="skeleton-table">
                        <ngx-skeleton-loader [theme]="{
                            height: '72px',
                            width: '100%',
                            marginBottom: '0'
                        }">
                        </ngx-skeleton-loader>
                    </div>
                    <app-table
                        *ngIf="!loadingCompanyRepresentatives && companyRepresentatives.length > 0"
                        [columns]="companyRepresentativesColumns"
                        [data]="companyRepresentatives" [removeButton]="true">
                    </app-table>
                    <div *ngIf="!loadingCompanyRepresentatives && companyRepresentatives.length === 0"
                        class="pep-title">
                        Nenhum representante vinculado
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>

            <!-- Dados da Pessoa -->
            <ng-container *ngIf="!isCompanyRepresentative()">
                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        cpf
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.document_number ?
                        formatCpf(selectedRepresentative.document_number) :
                        '--'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-badged"
                        *ngIf="selectedRepresentative.pep">
                        Declarado PEP
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        Avalista
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.guarantor ?
                        'Sim' : 'Não'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        Devedor solidário
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.solidarity_debtor
                        ? 'Sim' : 'Não'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <ng-container
                    *ngIf="!isContribuitor && !isCompanyRepresentative()">
                    <div class="col-12 d-flex flex-column"
                        *ngIf="selectedRepresentative?.representative_register?.person?.birth_date">
                        <span class="dash-details-card-item-subtitle">
                            DATA DE NASCIMENTO
                        </span>

                        <span class="dash-details-card-item-title">
                            {{selectedRepresentative.birth_date ?
                            formatDate(selectedRepresentative.birth_date) :
                            formatDate(selectedRepresentative.representative_register?.person?.birth_date)}}
                        </span>
                        <app-spacer [bottom]="16"></app-spacer>
                    </div>

                    <ng-container>
                        <div div class="col-12 col-md-6 d-flex flex-column">
                            <span class="dash-details-card-item-subtitle">
                                TIPO DE DOCUMENTO
                            </span>

                            <span class="dash-details-card-item-title">
                                {{
                                selectedRepresentative.representative_register?.person?.secondary_document?.type?.name
                                ?? '--'
                                }}
                            </span>
                            <app-spacer [bottom]="16"></app-spacer>
                        </div>

                        <div class="col-12 col-md-6 d-flex flex-column">
                            <span class="dash-details-card-item-subtitle">
                                DOCUMENTO
                            </span>

                            <span class="dash-details-card-item-title">
                                {{selectedRepresentative.representative_register?.person?.secondary_document?.number
                                ?? '--'}}
                            </span>
                            <app-spacer [bottom]="16"></app-spacer>
                        </div>

                        <div class="col-12 col-md-6 d-flex flex-column">
                            <span class="dash-details-card-item-subtitle">
                                ÓRGÃO EXPEDITOR
                            </span>

                            <span class="dash-details-card-item-title">
                                <ng-container
                                    *ngIf="selectedRepresentative.representative_register?.person?.secondary_document?.uf">
                                    {{selectedRepresentative.representative_register?.person?.secondary_document?.uf}}/
                                </ng-container>
                                {{selectedRepresentative.representative_register?.person?.secondary_document?.dispatching_agency
                                ?? '--'}}
                            </span>
                            <app-spacer [bottom]="16"></app-spacer>
                        </div>

                        <div class="col-12 col-md-6 d-flex flex-column">
                            <span class="dash-details-card-item-subtitle">
                                DATA DE EXPEDIÇÃO
                            </span>

                            <span class="dash-details-card-item-title">
                                {{selectedRepresentative.representative_register?.person?.secondary_document?.expedition_date
                                |
                                date: 'dd/MM/yyyy' ?? '--'}}
                            </span>
                            <app-spacer [bottom]="16"></app-spacer>
                        </div>
                    </ng-container>

                    <div class="col-12 d-flex flex-column">
                        <span class=" dash-details-card-item-subtitle">
                            Ocupação profissional
                        </span>

                        <span class="dash-details-card-item-title">
                            {{
                            selectedRepresentative.representative_register?.person?.occupation
                            ?? '--'
                            }}
                        </span>
                        <app-spacer [bottom]="16"></app-spacer>
                    </div>

                    <div class="col-12 col-md-6 d-flex flex-column">
                        <span class="dash-details-card-item-subtitle">
                            País de origem
                        </span>

                        <span class="dash-details-card-item-title">
                            {{
                            getNacionality(selectedRepresentative.representative_register?.person?.naturalness)?.label
                            ??'--'
                            }}
                        </span>
                        <app-spacer [bottom]="16"></app-spacer>
                    </div>

                    <div class="col-12 col-md-6 d-flex flex-column">
                        <span class="dash-details-card-item-subtitle">
                            NATURALIDADE
                        </span>

                        <span class="dash-details-card-item-title">
                            <ng-container
                                *ngIf="selectedRepresentative.representative_register?.person?.naturalness_city && selectedRepresentative.representative_register?.person?.naturalness_city.name !== ''">
                                {{selectedRepresentative.representative_register?.person?.naturalness_city.name}}
                                /
                            </ng-container>
                            {{selectedRepresentative?.representative_register?.person?.naturalness_state?.name
                            &&
                            selectedRepresentative?.representative_register?.person?.naturalness_state?.name
                            !== '' ?
                            selectedRepresentative?.representative_register?.person?.naturalness_state?.name
                            : '--'}}
                        </span>
                        <app-spacer [bottom]="16"></app-spacer>
                    </div>

                    <div class="col-12 d-flex flex-column"
                        [class.col-md-6]="selectedRepresentative.spouse">
                        <span class="dash-details-card-item-subtitle">
                            estado civil
                        </span>

                        <span class="dash-details-card-item-title">
                            {{selectedRepresentative.representative_register?.person?.marital_status_display
                            ?? '--'}}
                        </span>
                        <app-spacer [bottom]="16"></app-spacer>
                    </div>
                </ng-container>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        regime de casamento
                    </span>

                    <span class="dash-details-card-item-title">
                        {{getChoicesName('marital_statutes',selectedRepresentative.representative_register?.person?.spouse?.marriage_bond)?.label
                        ?? '--'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        cpf do cônjuge
                    </span>

                    <span class="dash-details-card-item-title">
                        <ng-container
                            *ngIf="selectedRepresentative.representative_register?.person?.spouse?.document">
                            {{formatCpf(selectedRepresentative.representative_register?.person?.spouse?.document)}}
                        </ng-container>

                        <ng-container
                            *ngIf="!selectedRepresentative.representative_register?.person?.spouse?.document">
                            --
                        </ng-container>
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        nome do cônjuge
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.representative_register?.person?.spouse?.name
                        ?? '--'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        Possui outorga uxória
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.spousal_consent
                        ? 'Sim' : 'Não'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        celular
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.representative_register?.person?.cellphone?
                        formatNumber(selectedRepresentative.representative_register?.person?.cellphone)
                        :
                        '--'
                        }}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>


                <div class="col-12 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        e-mail
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.representative_register?.person?.email
                        &&
                        selectedRepresentative.representative_register?.person?.email
                        !== ' ' ?
                        selectedRepresentative.representative_register?.person?.email
                        :
                        '--'}}
                        <!-- selectedRepresentative.info.register.person.email -->
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        início do mandato
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.min_term_validity ?
                        formatDate(selectedRepresentative.min_term_validity) :
                        '--'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 col-md-6 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        validade do mandato
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedRepresentative.expiration_date ?
                        formatDate(selectedRepresentative.expiration_date) :
                        'indeterminado'}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <ng-container *ngIf="!isContribuitor">
                    <div class="col-12 col-md-6 d-flex flex-column"
                        *ngIf="selectedRepresentative.representative_register.address">
                        <span class="dash-details-card-item-subtitle">
                            endereço completo
                        </span>

                        <span class="dash-details-card-item-title"
                            *ngIf="selectedRepresentative.representative_register.address.cep">
                            {{selectedRepresentative.representative_register.address
                            ?
                            formatAddress(selectedRepresentative.representative_register.address)
                            : '--'}}<br>
                            {{selectedRepresentative.representative_register.address
                            ?
                            selectedRepresentative.representative_register.address.cep
                            :
                            '--'}}
                        </span>

                        <span class="dash-details-card-item-title"
                            *ngIf="!selectedRepresentative.representative_register.address.cep">
                            --
                        </span>
                        <app-spacer [bottom]="32"></app-spacer>
                    </div>
                </ng-container>
            </ng-container>
        </div>

        <ng-container
            *ngIf="selectedRepresentative.files && selectedRepresentative.files.length > 0 ">
            <div class="row">
                <div class="col-12">
                    <h3>Anexos</h3>
                </div>
                <!-- <div class="col-12">
                    <app-attachment-button
                        [files]="selectedRepresentative.files" [full]="true"
                        (onSelect)="handleSelect($event)"></app-attachment-button>
                </div> -->
            </div>
            <app-spacer [bottom]="32"></app-spacer>
        </ng-container>

        <!-- <div class="row">
            <div class="col-12" *ngIf="pepData.length > 0">
                <div class="dash-details-card" style="box-shadow:none;">
                    <div class="dash-details-card-header p-0">
                        <h3>Possui relacionamento com PEP</h3>
                    </div>

                    <app-table-list [columns]="pepColumns" [data]="pepData" [custom]="true"></app-table-list>
                </div>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div> -->
    </div>
</app-side-modal>

<app-modal #modalRoot class="modal-demo">
    <ng-container class="app-modal-header">
        <ng-container *ngIf="file">
            <svg-icon src="assets/images/icon_drag_indicator.svg"></svg-icon>
            <div>{{file.type.name}}</div>
            <div></div>
        </ng-container>
    </ng-container>
    <ng-container class="app-modal-body">
        <ng-container *ngIf="file">
            <img [src]="url" *ngIf="!isPDF && !isXLS" style="width:100%">
            <iframe [src]="url" *ngIf="isPDF || isXLS" frameborder="0"
                height="100%" width="100%">
            </iframe>
        </ng-container>
    </ng-container>
</app-modal>